import React from 'react';
import { Box } from '@mui/material';
import DataList from '../dataList/dataList';

const CommonRequests = (props) => {
    return (
        <Box className="contentBox">
            <DataList
                moduleDisplayName={props.moduleDisplayName}
                showHistory={props.showHistory}
                data={props.data}
                hideEdit={props.hideEdit}
                // onCheckSelect={onCheckSelect}
                editRow={props.editRow}
                editAll={props.editAll}
                showEdit={props.showEdit ? true : false}
                editButtonTitle={props.editButtonTitle}
                handleClick={props.handleClick}
                title={props.title}
                outfitInfo={props.outfitInfo}
                buttonTitle={props.buttonTitle}
                deleteRows={props.deleteRows}
                showSearch={props.showSearch}
                searchLabel={props.searchLabel}
                showFilter={props.showFilter}
                filters={props.filters}
                hideAdd={props.hideAdd == true ? true : false}
                showSearchRec={props.showSearchRec}
                setShowSearchRec={props.setShowSearchRec}
                onSwitchToggle={props.onSwitchToggle}
                onActionClick={props.onActionClick}
                showSync={props.showSync}
                showExport={props.showExport}
                showSettings={props.showSettings}
                callExport={props.callExport}
                getResults={props.getResults}
                pagingInfo={props.pagingInfo}
                handlePageChange={props.handlePageChange}
                onPendingAction={props.onPendingAction}
                moduleToShow={props.moduleToShow}
                modPermission={props.modPermission}
                filterListData={props.filterListData}
                disableAdd={props.disableAdd}
                hideDelete={
                    props.hideDelete != undefined ? props.hideDelete : false
                }
                showHotelToggle={props.showHotelToggle}
                asListRoomTax={props.asListRoomTax}
                handleChangeRoomTax={props.handleChangeRoomTax}
                showEditHotel={props.showEditHotel ? true : false}
                saveHotelButtonTitle={props.saveHotelButtonTitle}
                editAllToggle={props.editAllToggle}
                eventConfigStatus={props.eventConfigStatus}
                compUsed={props.compUsed}
                purchaseUsed={props.purchaseUsed}
                hotelKeyValue={props.hotelKeyValue}
                pendingWaitList={props.pendingWaitList}
                approvedWaitList={props.approvedWaitList}
                eventConfig={props.eventConfig}
                endUserView={props.endUserView}
                showAgentRoomInfo={props.showAgentRoomInfo}
                isAgentRequestAccepted={props.isAgentRequestAccepted}
                handleAgentRoomConfirmation={props.handleAgentRoomConfirmation}
                handleFinalSubmit={props.handleFinalSubmit}
                finalSubmit={props.finalSubmit}
                disbaleFinalSubmit={props.disbaleFinalSubmit}
                credentailDropdown={props.credentailDropdown}
                dropdownUsedCount={props.dropdownUsedCount}
            />
        </Box>
    );
};

export default CommonRequests;
